import React, { forwardRef } from 'react';
import { cn } from '@/utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({ className, error, startIcon, endIcon, ...props }, ref) => {
  return (
    <div className="relative w-full">
      {startIcon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center pointer-events-none">
          {startIcon}
        </div>
      )}
      <input
        ref={ref}
        {...props}
        className={cn(
          // Layout & size
          'h-[38px] w-full text-[14px] rounded-[8px]',
          // Padding adjustments based on icons
          startIcon ? 'pl-[40px]' : 'pl-[12px]',
          endIcon ? 'pr-[40px]' : 'pr-[12px]',
          // Base colors
          'border border-[#D9D9D9] text-[#4B4B4B] bg-[#ffffff]',
          // Focus & transition
          'outline-none transition-all duration-150',
          'focus:border-[#0C8DBF]',
          // Error state
          error && 'border-[#CC0202] focus:border-[#CC0202] focus-visible:ring-[#CC0202]/30',
          // Custom overrides
          className
        )}
      />
      {endIcon && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center">{endIcon}</div>
      )}
    </div>
  );
});

Input.displayName = 'Input';
export default Input;
